import React, { useEffect, useState, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import { Button, Form, Row, Col, Alert } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Spinner from '../../../shared/spinner';

import { PontoVendaDTO } from '../../../shared/dto/pontoVendaDTO';
import { GerenteDTO } from '../../../shared/dto/gerenteDTO';
import { MatrizDTO } from '../../../shared/dto/matrizDTO';
import { PromotoraDTO } from '../../../shared/dto/promotoraDTO';

import { ButtonAlterar, ButtonAtivar, ButtonInativar, ButtonInfoGerais } from '../../../shared/buttons';

import PontoVendaService from '../../../services/pontoVendaService';
import SupervisorService from '../../../services/supervisorService';
import MatrizService from '../../../services/matrizService';
import PromotoraService from '../../../services/promotoraService';
import ImportacaoService from '../../../services/importacaoService'; // <--- Importado

import ConfirmModal from '../../../shared/customAlertConfirm';
import { useVerificaPermissao } from '../../../shared/useVerificaPermissao';

//Paginação
import ResponsivePagination from 'react-responsive-pagination';

//Filtros e Ícones
import { faFilter, faRefresh, faFileImport, faDownload, faTimes } from '@fortawesome/free-solid-svg-icons'; // <--- Novos ícones
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ProtectedActionInterno } from '../../../AccessControl';
import { useSlug } from '../../hooks/UseSlug';
import { ProtectedAction } from '../../../AccessControl';

function PontoVendaComponent() {
  useVerificaPermissao();
  const navigate = useNavigate();
  const slug = useSlug(); // 2. Obtendo o slug


  // Services
  const pontoVendaService: PontoVendaService = new PontoVendaService();
  const supervisorService = new SupervisorService();
  const matrizService = new MatrizService();
  const promotoraService = new PromotoraService();
  const importacaoService = new ImportacaoService(); // <--- Instância

  // States Principais
  const [loading, setLoading] = useState(false);
  const [pontoVenda, setPontoVenda] = useState<PontoVendaDTO[]>([]);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [currentAction, setCurrentAction] = useState<{ id: any; ativo: boolean } | null>(null);

  //Paginação
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [totalPaginas, setTotalPaginas] = useState(1);

  //Controle de Painéis
  const [filtros, setFiltros] = useState(false);
  const [importacaoOpen, setImportacaoOpen] = useState(false); // <--- State Painel Importação

  //Filtros States
  const [matrizFiltro, setMatrizFiltro] = useState('');
  const [promotoraFiltro, setPromotoraFiltro] = useState('');
  const [supervisorFiltro, setSupervisorFiltro] = useState('');
  const [operadorFiltro, setOperadorFiltro] = useState('');
  const [codigoFiltro, setCodigoFiltro] = useState('');
  const [nomeFiltro, setNomeFiltro] = useState('');
  const [cidadeFiltro, setCidadeFiltro] = useState('');
  const [statusOrigemFiltro, setStatusOrigemFiltro] = useState('');
  const [cpfCnpjFiltro, setCpfCnpjFiltro] = useState('');

  const [matrizes, setMatrizes] = useState<MatrizDTO[]>([]);
  const [promotoras, setPromotoras] = useState<PromotoraDTO[]>([]);
  const [supervisores, setSupervisores] = useState<GerenteDTO[]>([]);

  // States de Importação
  const [fileToUpload, setFileToUpload] = useState<File | null>(null);
  const [importLoading, setImportLoading] = useState(false);
  const [importMessage, setImportMessage] = useState<{ type: 'success' | 'danger', text: string } | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  // --- Toggle Painéis ---
  const toggleFiltros = () => {
    setFiltros(!filtros);
    setImportacaoOpen(false); // Fecha importação ao abrir filtros
  };

  const toggleImportacao = () => {
    setImportacaoOpen(!importacaoOpen);
    setFiltros(false); // Fecha filtros ao abrir importação
    setImportMessage(null);
  };

  // --- Listagem ---
  const listarTodosPontosVendas = async (page = 1, size = 10) => {
    try {
      setLoading(true);

      const filtros = {
        codigo: codigoFiltro || null,
        nome: nomeFiltro || null,
        cpfCnpj: cpfCnpjFiltro || null,
        cidade: cidadeFiltro || null,
        statusOrigem: statusOrigemFiltro !== '' ? statusOrigemFiltro === 'true' : null,
        matriz: matrizFiltro ? Number(matrizFiltro) : null,
        promotora: promotoraFiltro ? Number(promotoraFiltro) : null,
        supervisor: supervisorFiltro ? Number(supervisorFiltro) : null,
        operador: operadorFiltro || null
      };

      const responseList = await pontoVendaService.listarTodosPontosVendas(
        page - 1,
        size,
        filtros
      );

      const data = responseList.data;
      setPontoVenda(data.content);
      setTotalPaginas(data.totalPages);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const ativarInativarPontoVenda = async (id: any, ativo: boolean) => {
    setCurrentAction({ id, ativo });
    setConfirmOpen(true);
  };

  const handleConfirm = async () => {
    if (currentAction) {
      const { id, ativo } = currentAction;

      try {
        await pontoVendaService.ativarInativarPontoVenda(id);
        listarTodosPontosVendas(paginaAtual);
      } catch (err) {
        console.error(err);
      } finally {
        setConfirmOpen(false);
        setCurrentAction(null);
      }
    }
  };

  function formatarCpfCnpj(valor: string): string {
    valor = valor.replace(/\D/g, '');

    if (valor.length <= 11) {
      valor = valor.replace(/^(\d{3})(\d)/, '$1.$2');
      valor = valor.replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3');
      valor = valor.replace(/\.(\d{3})(\d)/, '.$1-$2');
      return valor.slice(0, 14);
    } else {
      valor = valor.replace(/^(\d{2})(\d)/, '$1.$2');
      valor = valor.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
      valor = valor.replace(/\.(\d{3})(\d)/, '.$1/$2');
      valor = valor.replace(/(\d{4})(\d)/, '$1-$2');
      return valor.slice(0, 18);
    }
  }

  // --- LÓGICA DE IMPORTAÇÃO ---
  const handleDownloadModelo = async () => {
    try {
      // Backend espera 'PONTO_VENDA' para gerar o modelo correto
      const response = await importacaoService.baixarModelo('PONTO_VENDA');

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'modelo_importacao_ponto_venda.xlsx');
      document.body.appendChild(link);
      link.click();
      link.parentNode?.removeChild(link);
    } catch (error) {
      console.error("Erro ao baixar modelo", error);
      setImportMessage({ type: 'danger', text: 'Erro ao baixar o modelo.' });
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setImportMessage(null);
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      const extension = file.name.split('.').pop()?.toLowerCase();

      if (extension !== 'xlsx' && extension !== 'csv') {
        setImportMessage({ type: 'danger', text: 'Formato inválido. Apenas .xlsx e .csv são permitidos.' });
        setFileToUpload(null);
        if (fileInputRef.current) fileInputRef.current.value = "";
        return;
      }
      setFileToUpload(file);
    }
  };

  const handleImportar = async () => {
    if (!fileToUpload) {
      setImportMessage({ type: 'danger', text: 'Selecione um arquivo para importar.' });
      return;
    }

    try {
      setImportLoading(true);
      // Usamos 'PONTO-VENDA' com hífen para o endpoint ficar /ponto-venda
      await importacaoService.importar('PONTO-VENDA', fileToUpload);

      setImportMessage({ type: 'success', text: 'Importação realizada com sucesso!' });
      setFileToUpload(null);
      if (fileInputRef.current) fileInputRef.current.value = "";

      // Recarrega lista
      listarTodosPontosVendas(1);

      // Fecha painel após sucesso
      setTimeout(() => {
        setImportacaoOpen(false);
        setImportMessage(null);
      }, 3000);

    } catch (error: any) {
      console.error("Erro na importação", error);
      const msg = error.response?.data || 'Erro ao processar importação.';
      setImportMessage({ type: 'danger', text: msg });
    } finally {
      setImportLoading(false);
    }
  };


  // --- Efeitos ---

  useEffect(() => {
    const carregarMatrizes = async () => {
      try {
        const response = await matrizService.listarTodasMatrizesAtivas();
        setMatrizes(response.data || []);
      } catch (error) {
        console.error("Erro ao carregar matrizes:", error);
      }
    };
    carregarMatrizes();
  }, []);

  useEffect(() => {
    const carregarPromotorasFiltradas = async () => {
      if (matrizFiltro) {
        try {
          const filtros = { matriz: matrizFiltro };
          const response = await promotoraService.listarTodasPromotoras(0, 9999999, filtros);
          const data = response.data;
          setPromotoras(Array.isArray(data.content) ? data.content : []);
        } catch (error) {
          console.error("Erro ao carregar promotoras filtradas:", error);
          setPromotoras([]);
        }
      } else {
        setPromotoras([]);
        setPromotoraFiltro("");
      }
    };
    carregarPromotorasFiltradas();
  }, [matrizFiltro]);

  useEffect(() => {
    const carregarSupervisoresFiltrados = async () => {
      if (promotoraFiltro) {
        try {
          const filtros = { promotora: promotoraFiltro };
          const response = await supervisorService.listarTodosGerentes(0, 9999999, filtros);
          const data = response.data;
          setSupervisores(Array.isArray(data.content) ? data.content : []);
        } catch (error) {
          console.error("Erro ao carregar supervisores filtrados:", error);
          setSupervisores([]);
        }
      } else {
        setSupervisores([]);
        setSupervisorFiltro("");
      }
    };
    carregarSupervisoresFiltrados();
  }, [promotoraFiltro]);

  useEffect(() => {
    listarTodosPontosVendas(paginaAtual);
  }, [paginaAtual]);

  return (
    <div className="position-relative m-md-3">
      <div style={{ marginBottom: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h5>Origens &gt; Ponto de Venda</h5>
        <div style={{ display: 'flex', gap: '10px' }}>
          {/* Botão Filtros */}
          <Button id="App-button-cor-principal-escura" onClick={toggleFiltros} active={filtros}>
            <FontAwesomeIcon icon={faFilter} style={{ marginRight: '10px' }} />
            Filtros
          </Button>

          {/* Botão Importar */}
          <ProtectedActionInterno>
            <Button variant="outline-primary" onClick={toggleImportacao} active={importacaoOpen}>
              <FontAwesomeIcon icon={faFileImport} style={{ marginRight: '10px' }} />
              Importar
            </Button>
          </ProtectedActionInterno>
          <ProtectedAction>
            <Button
              onClick={() => navigate(`${slug ? `/${slug}` : ''}/origens-ponto-venda/inclusao`, { state: { id: null } })}
              id="App-button-cor-principal-escura"
            >
              + Novo Ponto de Venda
            </Button>
          </ProtectedAction>
        </div>
      </div>

      {/* --- ÁREA DE IMPORTAÇÃO --- */}
      {importacaoOpen && (
        <div className="card card-body mb-4" style={{ backgroundColor: '#f8f9fa', border: '1px solid #dee2e6' }}>
          <h6 className="card-title mb-3">
            <FontAwesomeIcon icon={faFileImport} className="me-2" />
            Importação em Lote
          </h6>
          <Row className="align-items-end g-3">
            <Col md={3}>
              <Form.Label>Passo 1: Modelo</Form.Label>
              <Button variant="outline-secondary" className="w-100" onClick={handleDownloadModelo}>
                <FontAwesomeIcon icon={faDownload} className="me-2" />
                Baixar Modelo
              </Button>
            </Col>

            <Col md={5}>
              <Form.Group controlId="formFile">
                <Form.Label>Passo 2: Selecione o Arquivo (.xlsx)</Form.Label>
                <Form.Control
                  type="file"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                  accept=".xlsx, .csv"
                />
              </Form.Group>
            </Col>

            <Col md={4} className="d-flex gap-2">
              <Button
                id="App-button-cor-principal-escura"
                className="flex-grow-1"
                onClick={handleImportar}
                disabled={!fileToUpload || importLoading}
              >
                {importLoading ? <Spinner loading={true} /> : 'Confirmar Importação'}
              </Button>
              <Button variant="secondary" onClick={() => {
                setImportacaoOpen(false);
                setImportMessage(null);
                setFileToUpload(null);
              }}>
                <FontAwesomeIcon icon={faTimes} />
              </Button>
            </Col>
          </Row>

          {importMessage && (
            <Alert variant={importMessage.type} className="mt-3 mb-0">
              {importMessage.text}
            </Alert>
          )}
        </div>
      )}

      {/* --- ÁREA DE FILTROS --- */}
      {filtros ?
        <>
          <Row className="mb-4" style={{ marginTop: '15px' }}>
            <Form.Group as={Col} md='2' controlId="formSelectMatriz">
              <Form.Label>Matriz</Form.Label>
              <Form.Select value={matrizFiltro} onChange={(e) => setMatrizFiltro(e.target.value)}>
                <option value="">Selecione</option>
                {matrizes.map((matriz) => (
                  <option key={matriz.id} value={String(matriz.id)}>
                    {matriz.id} - {matriz.nome}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group as={Col} md='2' controlId="formSelectPromotora">
              <Form.Label>Promotora</Form.Label>
              <Form.Select value={promotoraFiltro} onChange={(e) => setPromotoraFiltro(e.target.value)}>
                <option value="">Selecione</option>
                {promotoras.map((promotora) => (
                  <option key={promotora.id} value={String(promotora.id)}>
                    {promotora.id} - {promotora.nome}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group as={Col} md='2' controlId="formSelectSupervisores">
              <Form.Label>Supervisor</Form.Label>
              <Form.Select value={supervisorFiltro} onChange={(e) => setSupervisorFiltro(e.target.value)}>
                <option value="">Selecione</option>
                {supervisores.map((supervisor) => (
                  <option key={supervisor.id} value={String(supervisor.id)}>
                    {supervisor.id} - {supervisor.nome}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group as={Col} md='2' controlId="formBasicSelect">
              <Form.Label>Operador </Form.Label>
              <input type="text" className="form-control" value={operadorFiltro} onChange={(e) => setOperadorFiltro(e.target.value)} />
            </Form.Group>
            <Form.Group as={Col} md='4' controlId="formBasicSelect">
              <Form.Label>Nome</Form.Label>
              <input type="text" className="form-control" value={nomeFiltro} onChange={(e) => setNomeFiltro(e.target.value)} />
            </Form.Group>
            <Form.Group as={Col} md='2' controlId="formBasicSelect">
              <Form.Label>Código </Form.Label>
              <input type="text" className="form-control" value={codigoFiltro} onChange={(e) => setCodigoFiltro(e.target.value)} />
            </Form.Group>
            <Form.Group as={Col} md='4' controlId="formBasicSelect">
              <Form.Label>Cidade</Form.Label>
              <input type="text" className="form-control" value={cidadeFiltro} onChange={(e) => setCidadeFiltro(e.target.value)} />
            </Form.Group>
            <Form.Group as={Col} md='4' controlId="formSelectStatusOrigem">
              <Form.Label>Status Origem</Form.Label>
              <Form.Select
                value={statusOrigemFiltro}
                onChange={(e) => setStatusOrigemFiltro(e.target.value)}
              >
                <option value="">Todas</option>
                <option value="true">Ativas</option>
                <option value="false">Inativas</option>
              </Form.Select>
            </Form.Group>
            <Form.Group as={Col} md='4' controlId="formBasicSelect">
              <Form.Label>CPF/CNPJ</Form.Label>
              <input
                type="text"
                className="form-control"
                value={cpfCnpjFiltro}
                onChange={(e) => setCpfCnpjFiltro(formatarCpfCnpj(e.target.value))}
                maxLength={18}
              />
            </Form.Group>
          </Row>

          <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'space-between' }}>
            <Button id="App-button-cor-principal-escura" onClick={() => listarTodosPontosVendas(1)}>
              <FontAwesomeIcon icon={faFilter} style={{ marginRight: '1px' }} />
              Aplicar
            </Button>
            <Button variant="secondary" onClick={() => {
              setMatrizFiltro(''); setPromotoraFiltro(''); setSupervisorFiltro(''); setOperadorFiltro('');
              setCodigoFiltro(''); setNomeFiltro(''); setCidadeFiltro(''); setStatusOrigemFiltro(''); setCpfCnpjFiltro('');
              listarTodosPontosVendas(1);
            }}>
              <FontAwesomeIcon icon={faRefresh} style={{ marginRight: '1px' }} />
              Limpar
            </Button>
          </div>
        </>
        : null}

      {loading ? <Spinner loading={loading} /> : (
        <div className="table-responsive">
          <div>
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th scope="col" id="App-header-table">Ponto de Venda</th>
                  <th scope="col" id="App-header-table">CPF/CNPJ</th>
                  <th scope="col" id="App-header-table">Cidade</th>
                  <th scope="col" id="App-header-table">Telefone</th>
                  <th scope="col" id="App-header-table">E-mail</th>
                  <th scope="col" id="App-header-table">Operador</th>
                  <th scope="col" id="App-header-table">Inf. Gerais</th>
                  <ProtectedAction>
                    <th scope="col" id="App-header-table">Alteração</th>
                    <th scope="col" id="App-header-table">Status</th>
                  </ProtectedAction>
                </tr>
              </thead>
              <tbody>
                {pontoVenda.map((item) => (
                  <tr>
                    <td>{item.id} - {item.nome}</td>
                    <td>{item.cpfCnpj}</td>
                    <td>{item.cidade}</td>
                    <td>{item.telefoneComercial}</td>
                    <td>{item.email}</td>
                    <td>{item.operador} - {item.nomeOperador}</td>
                    <td>
                      <Link
                        to={`${slug ? `/${slug}` : ''}/controle-rmc-informacoes-gerais`}
                        state={{ chamada: 'promotora', idPromotora: item.id, idEmpregador: 0 }}
                      >
                        <ButtonInfoGerais />
                      </Link>
                    </td>
                    <ProtectedAction>
                      <td>
                        <Link to={`${slug ? `/${slug}` : ''}/origens-ponto-venda/alteracao`} state={{ id: item.id }}>
                          <ButtonAlterar />
                        </Link>
                      </td>
                      <td>
                        {item.ativo ?
                          <ButtonInativar onClick={() => ativarInativarPontoVenda(item.id, item.ativo)} />
                          :
                          <ButtonAtivar onClick={() => ativarInativarPontoVenda(item.id, item.ativo)} />
                        }
                      </td>
                    </ProtectedAction>
                  </tr>
                ))}
              </tbody>
            </table>
            <ResponsivePagination
              current={paginaAtual}
              total={totalPaginas}
              onPageChange={(page) => setPaginaAtual(page)}
            />

            {confirmOpen && (<ConfirmModal message={currentAction?.ativo ? 'Tem certeza que deseja inativar este item?' : 'Tem certeza que deseja ativar este item?'} onConfirm={handleConfirm} onCancel={() => { setConfirmOpen(false); setCurrentAction(null) }} />)}
          </div>
        </div>
      )}
    </div>
  );
}

export default PontoVendaComponent;